import { AppConfig } from 'config/app';
import * as JSCookie from 'js-cookie';

/**
 * All communication to the backend is enabled by this commonly used function.
 */
export async function fetchGraphQL(
	query: string,
	token?: string,
	variables?: any,
): Promise<any> {
	const localToken = JSCookie.get('token');
	return fetch(AppConfig.apiUrl, {
		method: 'post',
		headers: {
			'Content-Type': 'application/json',
			Authorization: token || localToken || 'Unauthorized',
			Accept: 'application/json',
		},
		body: JSON.stringify({
			query,
			variables: variables || {},
		}),
	})
		.then(response => response.json())
		.then(data => {
			if (data.errors) {
				return data.data;
			}
			return data.data;
		})
		.catch(e => {
			// console.error(e);
		});
}



// WEBPACK FOOTER //
// ./src/services/graphql/GraphQL.tsx